import { ButtonWithLoader } from "@components/button_with_loader/button_with_loader";
import { FlashMessage } from "@components/flash_messages/flash_message";
import { useMutate } from "@hooks/use_mutate";
import { api } from "@services/api";
import { isNil } from "@services/typed_helpers";
import { Form, Formik } from "formik";
import React, { FC, useMemo } from "react";

import * as types from "../../../types";

const FlushCacheForm: FC = () => {
  const flushCache = useMemo(() => {
    return (token: string) => () => api.cache.flush(token);
  }, []);

  const {
    submitData: submit,
    loading,
    error: apiError,
    data,
  } = useMutate<types.FlushCacheResponse, unknown>(flushCache);
  const { errors } = data ?? {};
  const handleSubmit = () => {
    if (loading) {
      return;
    }
    submit({});
  };

  return (
    <>
      {errors ? <FlashMessage message={errors} type="error" /> : null}
      {apiError ? (
        <FlashMessage
          message="Something terrible has happened.  Please try again later."
          type="error"
        />
      ) : null}
      {!isNil(data?.message) ? (
        <FlashMessage message={data.message} type="notice" />
      ) : null}
      <Formik initialValues={{}} onSubmit={handleSubmit} id="flush_cache_form">
        <Form>
          <ButtonWithLoader
            secondary
            loading={loading}
            value="Flush Application Cache!"
          />
        </Form>
      </Formik>
    </>
  );
};

export { FlushCacheForm };
